import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { fetchGrade, createGrade, updateGrade, loadUnpagedGrades } from './actions';
import GradeSettingsForm from './SettingsForm';
import { getActiveLanguage } from '../../languages/reducer';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleGradeSettingsSubmit = this.handleGradeSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, loadUnpagedGrades, fetchGrade } = this.props;
		const gradeId = match.params.id;

		loadUnpagedGrades(null, () => {
			if (gradeId) {
				fetchGrade(gradeId);
			}
		});
	}

	handleGradeSettingsSubmit(values) {
		const { grade, createGrade, updateGrade, history } = this.props;
		if (values.subGrades) {
			values.subGrades = values.mixed ? values.subGrades.filter(x => x).map(x => x.id) : []; // do not need Grade entity, just the IDs
		}
		if (grade) {
			updateGrade(grade.id, values);
		} else {
			createGrade(values, history);
		}
	}

	render() {
		const { match, grade, isReadonly, lang, grades, mixed, isRestrictedUser, enableTrials, enableMakeUps, t } = this.props;

		const initialValues = grade && {
			...grade,
			subGrades: grade.subGrades && grade.subGrades.length > 0 ? grade.subGrades.map(id => grades.find(x => x.id === id)) : null
		};

		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<GradeSettingsForm form={match.params.id ? 'grade' : 'newGrade'} isReadonly={isReadonly} onSubmit={this.handleGradeSettingsSubmit} initialValues={initialValues} lang={lang}
					grades={grades} mixed={mixed} isRestrictedUser={isRestrictedUser} enableTrials={enableTrials} enableMakeUps={enableMakeUps} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const gradeId = ownProps.match.params.id;

	const {
		entities: { grades },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;
	const grade = grades[gradeId];
	return {
		lang: getActiveLanguage(state.configuration.language),
		grade,
		isReadonly: grade && grade.isReadonly,
		grades: Object.values(grades).filter(x => !x.mixed && x.isOnline && x.id !== Number(gradeId)),
		mixed: formValueSelector(gradeId ? 'grade' : 'newGrade')(state, 'mixed'),
		isRestrictedUser: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted,
		enableTrials: franchisor.enableTrials,
		enableMakeUps: franchisor.enableMakeUps
	};
};

export default connect(mapStateToProps, {
	fetchGrade,
	createGrade,
	updateGrade,
	loadUnpagedGrades
})(withTranslation()(Details));